module.exports = __webpack_public_path__ + "img/image4@2x.8b3dfd74.png";